<template>
    <transition name="fade">
        <div class="modal-wrapper">
            <button
                @click="close"
                class="modal-background"
            />

            <div class="modal-dialog">
                <button
                    @click="close"
                    aria-label="Sluiten"
                    class="modal-close"
                >
                    &times;
                </button>
                <slot />
            </div>
        </div>
    </transition>
</template>

<script>
    import { mapMutations } from 'vuex';

    export default {
        name: 'Modal',
        methods: {
            ...mapMutations('modal', [
                'setModal',
            ]),

            close() {
                this.setModal(null);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .modal {
        &-wrapper {
            position: absolute;
            top: 0;
            z-index: 999;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100vw;
            min-height: 100vh;
        }

        &-background {
            position: fixed;
            top: 0;
            width: 100%;
            height: 100%;
            background: rgba(#000, 0.5);
        }

        &-close {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
            margin: 16px;
            overflow: hidden;
            font-size: 40px;
            line-height: 24px;
            color: #000;
        }

        &-dialog {
            position: relative;
            width: 100%;
            max-width: calc(100% - 32px);
            padding: 20px;
            margin: 14px 0;
            overflow: hidden;
            background-color: #fff;

            @include respond-to(md) {
                width: 700px;
                padding: 44px;
            }

            @include respond-to(lg) {
                width: 850px;
                padding: 64px;
            }
        }
    }
</style>
